import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';
@Injectable({
    providedIn: 'root'
})
export class ResetPwdService {

    constructor(private httpService: HttpService) { }

    /**
     * Rests pwd
     * @author Starley Cazorla
     * @param cpf
     * @returns
     */
    async restPwd(cpf: string) {
        return new Promise((resolve, reject) => {
            try {

                let config = this.httpService.setHeaderConfig(false)

                this.httpService.post(UrlConnectionEnum.RESET_PWD, { cpf }, config).subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (error) => {
                        reject(error);
                    }
                });

            } catch (error) {
                reject(error);
            }
        });
    }

}
